/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Watery_Clean_Cougar_SnapInputs */

const fr_watery_clean_cougar_snap = /** @type {(inputs: Watery_Clean_Cougar_SnapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique`)
};

/**

* @param {Watery_Clean_Cougar_SnapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const watery_clean_cougar_snap = /** @type {((inputs?: Watery_Clean_Cougar_SnapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watery_Clean_Cougar_SnapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_watery_clean_cougar_snap(inputs)
});